import config from "@/config";

type GtagType = (command: string, eventName: string, eventParams?: Record<string, any>) => void;

export const gtagTrackEvent = (
  eventName: string,
  eventParams?: { event_category: string; event_action: string } | Record<string, any>
): void => {
  if (typeof (window as any).gtag === "function") {
    ((window as any).gtag as GtagType)("event", eventName, eventParams);
  }
};

export const gtagTrackEventScrile = (
  eventName: string,
  eventParams?: { event_category: string; event_action: string } | Record<string, any>
): void => {
  if (typeof (window as any).gtag === "function" && config.scrileGtagId) {
    ((window as any).gtag as GtagType)("event", eventName, {
      send_to: config.scrileGtagId,
      ...eventParams,
    });
  }
};
